import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as yup from 'yup';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

interface IWarehouseContext {
    isLoading: boolean
    warehouse: Warehouse

    saveWarehouse: (warehouse: Warehouse) => void
}

export let warehouseSchema = yup.object({
    id: yup.string().nullable().default(null),
    code: yup.string().required().default('').label('Code'),
    isVirtual: yup.boolean().default(false).label("Is virtual"),
    erpVendorCode: yup.string().default('').label("ERP Vendor Code"),
    warehouseList: yup.array(yup.string().default('')).default([]).label("Warehouse list"),
});

type Warehouse = yup.InferType<typeof warehouseSchema>;

export let warehouseContext = React.createContext({} as IWarehouseContext);

let { Provider } = warehouseContext;

let WarehouseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let navigate = useNavigate();
    let { enqueueSnackbar } = useSnackbar();

    let isNew = location.pathname.includes("/addnew");

    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [warehouse, setWarehouse] = useState<Warehouse>(warehouseSchema.getDefault());
    let [isSaving, setSaving] = useState(false);


    useEffect(() => {
        if (isNew === false)
            getWarehouse();

    }, [id, isNew])

    let getWarehouse = async () => {
        try {
            let res = await axios.get('/api/Warehouse/GetWarehouse', { params: { id } });

            let { item } = res.data;
            setWarehouse(item);

            setLoading(false);

        } catch (err) { }
    }

    let saveWarehouse = async (value: Warehouse) => {
        try {
            await axios.post('/api/Warehouse/SaveWarehouse', value);
            enqueueSnackbar("Warehouse saved", { variant: "success" });
            navigate(`/admin/warehouse`);

        } catch (err) {
            setSaving(false)
        }
    }

    return (
        <Provider
            value={{
                isLoading,
                warehouse,

                saveWarehouse
            }}
        >
            {children}
        </Provider>
    )
}

export default WarehouseProvider;